export default {
	login (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'auth/main_office/login', params)
	},
	logout (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'auth/main_office/logout', params)
	},
	check (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'auth/main_office/check', params)
	}
}



// WEBPACK FOOTER //
// ./src/api/MainOfficeAuth.js